import SaleIndex from './Index'
import SaleForm from './Form'
import SaleView from './View'

export default [
  {
    path: '/sale',
    name: 'sale',
    component: SaleIndex,
    meta: {
      auth: true,
      bodyClass: 'navbar-top',
      breadcrumb: 'Sales'
    }
  },
  {
    path: '/sale/details/:oid',
    name: 'sale.details',
    props: true,
    component: SaleView,
    meta: {
      breadcrumb: 'Sale Details'
    }
  },
  {
    path: '/sale/add',
    name: 'sale.create',
    props: true,
    component: SaleForm,
    meta: {
      breadcrumb: 'New sale'
    }
  }
]
